/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_EmptyInputs */



/**
* | output |
* | --- |
* | "No relays yet. Issue a key above and run oneai-agent against it." |
*
* @param {Agents_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agents_empty = /** @type {((inputs?: Agents_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine Relays. Erstellen Sie oben einen Schlüssel und starten Sie damit oneai-agent.")
	return /** @type {LocalizedString} */ ("No relays yet. Issue a key above and run oneai-agent against it.")
});